import React, { Suspense, useContext } from "react";
import "./BarInformationScreen.css"
import { AppContext } from "../../context/AppContext";
import { Link } from "react-router-dom";
import logoWhite from '../../image/logo/logoWhite.webp'
import Footer from "../HomeScreen/Footer/Footer";
import { FiChevronLeft } from "react-icons/fi";
import IconConnection from "../../components/iconConnection/iconConnection";
import ChunkErrorBoundary from "../../components/hook/chunkErrorBoundary";

const ConnectionScreen = React.lazy(() => import("../ConnectionScreen/ConnectionScreen"));
interface TopBarProps {
    title: string;
    linkBack?: string; 
}

const TopBar: React.FC<TopBarProps> = ({ title, linkBack }) => {
    const {connectionScreen } = useContext(AppContext);

    const showBackChevron = linkBack !== undefined;

    return (
        <div className="topBarInformationScreen flexAllCenter">

            {showBackChevron && (
                <Link to={linkBack!} className="chevronBackMobile">
                    <FiChevronLeft size={30} />
                </Link>
            )}

            <div className="logoContainerFooter">
                <Link to={"/"} >
                    <img className="logoTopBarInformationScreen pointer" src={logoWhite} loading="lazy" alt="logo "/>
                    <img className="logoTopBarInformationScreenTel" src={logoWhite} loading="lazy" alt="logo "/>
                </Link>
            </div>

            <div className="titleContainer">
                <p className="titleTopBar largeTitle">{title}</p>
            </div>
            <IconConnection />

            {connectionScreen && <ChunkErrorBoundary><Suspense fallback={null}><ConnectionScreen /> </Suspense></ChunkErrorBoundary>}
        </div>
    )
};

export { TopBar, Footer };
